module.exports = __webpack_public_path__ + "static/media/cq_ultima_settimana.3632c645.svg";